import { Eyebrow } from './Eyebrow'
import { Icon } from './Icon'
import styles from './CountStepper.module.css'

interface CountStepperProps {
  value: number
  onChange: (value: number) => void
  label?: string
  quick?: number[]
}

export function CountStepper({
  value,
  onChange,
  label = 'Quantidade',
  quick = [2, 3, 5],
}: CountStepperProps) {
  return (
    <div className={styles.wrap}>
      <Eyebrow>{label}</Eyebrow>
      <div className={styles.row}>
        <button
          type="button"
          className={styles.minus}
          aria-label="Diminuir quantidade"
          disabled={value <= 1}
          onClick={() => onChange(Math.max(1, value - 1))}
        >
          <Icon name="remove" size={18} />
        </button>
        <span className={styles.value} aria-live="polite">
          {value}
        </span>
        <button
          type="button"
          className={styles.plus}
          aria-label="Aumentar quantidade"
          onClick={() => onChange(value + 1)}
        >
          <Icon name="add" size={18} />
        </button>
        <div className={styles.quick}>
          {quick.map((n) => (
            <button
              key={n}
              type="button"
              className={styles.quickChip}
              aria-label={`Definir quantidade como ${n}`}
              onClick={() => onChange(n)}
            >
              {n}
            </button>
          ))}
        </div>
      </div>
    </div>
  )
}
